// 生命保険料控除（新契約 H24.1.1以後）
export const calcLifeInsuranceNew = (premium) => {
    if (premium <= 0) return 0;
    if (premium <= 20000) return premium;
    if (premium <= 40000) return Math.ceil(premium / 2) + 10000;
    if (premium <= 80000) return Math.ceil(premium / 4) + 20000;
    return 40000;
};

// 生命保険料控除（旧契約 H23.12.31以前）
export const calcLifeInsuranceOld = (premium) => {
    if (premium <= 0) return 0;
    if (premium <= 25000) return premium;
    if (premium <= 50000) return Math.ceil(premium / 2) + 12500;
    if (premium <= 100000) return Math.ceil(premium / 4) + 25000;
    return 50000;
};

// 生命保険料控除（カテゴリ別：新旧併用時の有利判定）
export const calcLifeInsuranceCategory = (newPremium, oldPremium) => {
    const newDeduction = calcLifeInsuranceNew(newPremium);  // 最大4万
    const oldDeduction = calcLifeInsuranceOld(oldPremium);  // 最大5万

    // 新旧併用: min(新+旧, 40000)
    const combined = Math.min(newDeduction + oldDeduction, 40000);

    // 旧のみと比較して大きい方を採用
    // （旧契約だけで4万超なら、旧単体の方が有利）
    return Math.max(combined, oldDeduction);
};

// 生命保険料控除合計を計算
export const calcLifeInsuranceTotal = (data) => {
    const general = calcLifeInsuranceCategory(
        data.general?.newContract || 0,
        data.general?.oldContract || 0
    );
    const caregiving = calcLifeInsuranceNew(data.caregiving?.newContract || 0);
    const pension = calcLifeInsuranceCategory(
        data.pension?.newContract || 0,
        data.pension?.oldContract || 0
    );
    // 合計上限: 12万円
    return Math.min(general + caregiving + pension, 120000);
};

// 旧長期損害保険料控除を計算
export const calcOldLongTermDeduction = (premium) => {
    if (premium <= 0) return 0;
    if (premium <= 10000) return premium;  // 1万円以下: 全額
    if (premium <= 20000) return Math.ceil(premium / 2) + 5000;  // 1万〜2万円: 1/2 + 5000
    return 15000;  // 2万円超: 一律1.5万円
};

// 地震保険料控除を計算
export const calcEarthquakeDeduction = (earthquake, oldLongTerm) => {
    // 地震保険: 全額（上限5万）
    const earthquakeDeduction = Math.min(earthquake || 0, 50000);
    // 旧長期損害保険料
    const oldLongTermDeduction = calcOldLongTermDeduction(oldLongTerm || 0);
    // 両方合計: 上限5万
    return Math.min(earthquakeDeduction + oldLongTermDeduction, 50000);
};

// 所得控除合計を計算
export const calcTotalDeductions = (deductions) => {
    if (!deductions) return 0;

    // A. 社会保険料控除（全額）
    const socialInsurance = (deductions.socialInsurance?.nationalHealth || 0)
        + (deductions.socialInsurance?.nationalPension || 0)
        + (deductions.socialInsurance?.pensionFund || 0);

    // B. 小規模企業共済等掛金控除（全額）
    const smallBusiness = (deductions.smallBusiness?.kyosai || 0)
        + (deductions.smallBusiness?.ideco || 0);

    // C. 生命保険料控除
    const lifeInsurance = calcLifeInsuranceTotal(deductions.lifeInsurance || {});

    // D. 地震保険料控除
    const earthquake = calcEarthquakeDeduction(
        deductions.earthquake?.earthquake || 0,
        deductions.earthquake?.oldLongTerm || 0
    );

    return socialInsurance + smallBusiness + lifeInsurance + earthquake;
};
